import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../App.routing'

type featureToggles =
    | 'the-west-grand-final-collection'
    | 'queens-legacy-listing'
    | 'queens-legacy-home'

type curations = 'afl-grand-final' | 'queens-legacy'
type themeOverrides = 'grand-final' | 'queens-legacy'
type layouts = '4-card' | '8-card'
interface cardLayoutProps {
    featureToggle: featureToggles
    curation: curations
    themeOverride: themeOverrides
    hideHeadingLink?: boolean
}

const fourCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
}: cardLayoutProps) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: themeOverride,
            verticalSpacing: 'lg',
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'lima',
                    props: {
                        section: 'default',
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                        },
                        cardLayout: [
                            ['teaserWithBackground'],
                            ['teaserWithBackground'],
                            ['teaserWithBackground'],
                            ['teaserWithBackground'],
                        ],
                        intermediateColumns: 2,
                        finalColumns: 4,
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            pageSize: 4,
                            offset: 0,
                        },
                        hasBorder: false,
                    },
                }),
            ],
        },
    })
}

const eightCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
    hideHeadingLink,
}: cardLayoutProps) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: themeOverride,
            verticalSpacing: 'lg',
            hideHeadingLink: hideHeadingLink,
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        verticalSpacing: 'gridGap',
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            offset: 0,
                            pageSize: 2,
                        },
                    },
                }),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: false,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    layoutRatio: '3:1',
                                    stretchColumns: true,
                                    verticalSpacing: 'sm',
                                    hasBorder: false,
                                    usePodcastToggleValue: true,
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                section: 'default',
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                },
                                                cardLayout: [
                                                    ['teaserWithBackground'],
                                                    [
                                                        'xsImage-mdNoImage-withBG',
                                                        'xsImage-mdNoImage-withBG',
                                                    ],
                                                    [
                                                        'xsImage-mdNoImage-withBG',
                                                        'xsImage-mdNoImage-withBG',
                                                    ],
                                                ],
                                                intermediateColumns: 3,
                                                finalColumns: 3,
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: curation,
                                                    pageSize: 5,
                                                    offset: 2,
                                                },
                                                hasBackground: false,
                                                hasBorder: false,
                                            },
                                        }),
                                    ],
                                    right: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                section: 'default',
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                },
                                                cardLayout: [
                                                    ['teaserWithBackground'],
                                                ],
                                                intermediateColumns: 1,
                                                finalColumns: 1,
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: curation,
                                                    pageSize: 1,
                                                    offset: 7,
                                                },
                                                hasBackground: false,
                                                hasBorder: false,
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        },
    })
}

export function getThemedSegment(props: {
    featureToggle: featureToggles
    layoutVersion: layouts
    curation: curations
    themeOverride: themeOverrides
    hideHeadingLink?: boolean
}) {
    if (props.layoutVersion === '4-card') {
        return fourCardLayout({
            featureToggle: props.featureToggle,
            curation: props.curation,
            themeOverride: props.themeOverride,
        })
    }
    return eightCardLayout({
        featureToggle: props.featureToggle,
        curation: props.curation,
        themeOverride: props.themeOverride,
        hideHeadingLink: props.hideHeadingLink,
    })
}
